import React from 'react';
import { Button, CircularProgress, Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { ContestFormDialogLayout, FormFooterButtons } from '../contests/ContestFormDialogLayout';

interface TeamRemoveMemberDialogProps {
  open: boolean;
  memberName: string;
  deleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const TeamRemoveMemberDialog = ({ open, memberName, deleting, onCancel, onConfirm }: TeamRemoveMemberDialogProps) => {
  const { t } = useTranslation('teams');
  return (
    <Dialog open={open} onClose={() => !deleting && onCancel()} maxWidth="xs" fullWidth aria-labelledby="delete-member-dialog-title">
      <ContestFormDialogLayout
        title={<span id="delete-member-dialog-title">{t('removeDialog.title')}</span>}
        subtitle={t('removeDialog.message', { name: memberName })}
        onClose={() => !deleting && onCancel()}
        footer={
          <>
            <FormFooterButtons onCancel={onCancel} hideSubmit />
            <Button
              variant="contained"
              color="error"
              onClick={onConfirm}
              disabled={deleting}
              startIcon={deleting ? <CircularProgress size={16} color="inherit" /> : <DeleteIcon />}
            >
              {deleting ? t('removeDialog.removing') : t('removeDialog.confirm')}
            </Button>
          </>
        }
      >
        {null}
      </ContestFormDialogLayout>
    </Dialog>
  );
};
